import Utils from '../utils';

const { Logger } = Utils;

class LaunchDarklyUtil {
	/**
	 * Check for any LaunchDarkly intialization errors and log the error
	 * Functional Components: useLDClientError() - Returns error object if there is any
	 * Class Components: Use waitForInitialization to catch any errors
	 * @param {object} ldClientContext
	 */
	static logIntializeError = ldClientContext => {
		const logError = error => {
			Logger.logToServer({
				category: 'page_view',
				message: 'LaunchDarkly initialization error',
				error,
			});
			console.error('LaunchDarkly initialization error:', error);
		};

		if (ldClientContext.waitForInitialization) {
			ldClientContext.waitForInitialization().catch(error => {
				logError(error);
			});
		} else {
			logError(ldClientContext);
		}
	};
}

export default LaunchDarklyUtil;
